import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadArchivedProducts = createAction('[ArchivedProducts] Load ArchivedProducts', props<{ request: string }>());

export const loadArchivedProductsSuccess = createAction(
  '[ArchivedProducts] Load ArchivedProducts Success',
  props<{ response: IProducts[] }>()
);

export const loadArchivedProductsFailure = createAction(
  '[ArchivedProducts] Load ArchivedProducts Failure',
  props<{ error: Error | any }>()
);
